export default __webpack_public_path__ + "static/media/about-page-img.96a7ab70.png";